import { Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useAuthCheck from "./Components/hooks/useAuthCheck";
import Login from "./Components/Pages/Login";
import Projects from "./Components/Pages/Projects";
import Teams from "./Components/Pages/Teams";
import RequireAuth from "./Components/util/RequireAuth";

function App() {
    const authChecked = useAuthCheck();

    return !authChecked ? (
        <div>Checking authentication....</div>
    ) : (
        <div>
            <Routes>
                <Route path="/" element={<Login />} />
                <Route
                    path="/teams"
                    element={
                        <RequireAuth>
                            <Teams />
                        </RequireAuth>
                    }
                />
                <Route
                    path="/projects"
                    element={
                        <RequireAuth>
                            <Projects />
                        </RequireAuth>
                    }
                />
            </Routes>

            <ToastContainer />
        </div>
    );
}

export default App;
